const article = {
  id: "zashchita-ot-nakrutki-konkurentami",
  metaTitle: "Накрутка ПФ конкурентами: как защитить сайт | Boostclick",
  metaDescription: "Что делать, если на сайт идёт накрутка от конкурентов: как зафиксировать факт, какие меры действительно работают, а какие бесполезны и вредят самому сайту.",
  type: "Гайд",
  category: "Поисковые системы",
  title: "Как защититься, если конкуренты накручивают ваш сайт",
  time: 7,
  data: "31.07.2026",
  imageUrl: "/blogImages/zashchita-ot-nakrutki-konkurentami/backgroundImage.svg",
  hasDescriptionHeader: true,
  description: `Порядок действий на случай, когда на сайт идёт чужой
  роботный трафик: что зафиксировать в первую очередь, как отделить
  роботов от живых посетителей и какие технические меры имеют смысл. Отдельный
  раздел — про меры, которые вредят сайту сильнее, чем сама накрутка.`,
  navigation: [
    { to: "stoit-li-panikovat", text: "Стоит ли паниковать" },
    { to: "zafiksirovat", text: "Шаг 1. Зафиксировать факт" },
    { to: "otdelit", text: "Шаг 2. Отделить роботов" },
    { to: "chto-rabotaet", text: "Шаг 3. Что действительно работает" },
    { to: "chego-ne-delat", text: "Чего делать не надо" },
    { to: "kuda-obrashchatsya", text: "Куда обращаться" },
    { to: "chto-ukreplyat", text: "Что укрепить параллельно" },
    { to: "korotko", text: "Коротко" },
  ],
  section: [
    {
      id: "stoit-li-panikovat",
      title: "Стоит ли паниковать",
      content: [
        {
          type: "Description",
          text: "Страх «конкуренты закрутят нас и сайт попадёт под фильтр» старше, чем большинство инструментов накрутки. Он понятен: владелец сайта не управляет чужими действиями и не может их остановить.",
        },
        {
          type: "Description",
          parts: [
            "Здесь важно понимать, куда сместился подход поисковых систем. По разборам отраслевых специалистов, за последние годы центр тяжести переехал с массовых санкций на обнуление подозрительных сигналов: неестественные визиты чаще не наказываются, а просто перестают учитываться (",
            { href: "https://www.rush-agency.ru/blog/nakrutka-povedencheskih-faktorov-v-2026/", text: "разбор Rush Agency, 2026" },
            "). Для того, кто накрутку заказал, это худший сценарий: деньги потрачены, эффекта нет. Для того, на кого её направили, — наоборот, хорошая новость.",
          ],
        },
        {
          type: "Description",
          text: "Это не значит, что делать ничего не нужно. Это значит, что действовать стоит по порядку, а не в панике: сначала измерить, потом отделить, потом чинить — и не ломать при этом сайт для живых людей.",
        },
      ],
    },
    {
      id: "zafiksirovat",
      title: "Шаг 1. Зафиксировать факт",
      content: [
        {
          type: "Description",
          text: "Всё, что делается дальше, опирается на то, что вы зафиксировали в самом начале. Через месяц часть данных будет недоступна.",
          style: { marginBottom: "8px" },
        },
        {
          type: "List",
          listType: "ol",
          items: [
            { bold: "Дата начала. ", text: "Найдите день, с которого поведение метрик изменилось, и запишите его. Дальше всё сравнивается с этой датой." },
            { bold: "Скриншоты отчётов. ", text: "Снимите отчёты Метрики за период до и после: роботность, источники, география, технологии, длительность визитов." },
            { bold: "Логи сервера. ", text: "Выгрузите журналы веб-сервера за интересующий период и сохраните их отдельно. Они ротируются, и через несколько недель нужного отрезка уже не будет." },
            { bold: "Позиции и показы. ", text: "Сохраните выгрузку по запросам из Вебмастера. Без неё через месяц невозможно будет сказать, просели вы или нет." },
            { bold: "Записи Вебвизора. ", text: "Отберите и сохраните несколько записей из подозрительной группы визитов." },
          ],
        },
        {
          type: "Footnote",
          textItalic: "Отдельным пунктом: спросите своего подрядчика по продвижению, не запускал ли он что-нибудь в эти дни. Значительная часть «атак конкурентов» заканчивается на этом вопросе.",
        },
      ],
    },
    {
      id: "otdelit",
      title: "Шаг 2. Отделить роботов от живых посетителей",
      content: [
        {
          type: "Description",
          parts: [
            "Пока роботные визиты смешаны с обычными, вы не видите реальной картины и не можете оценить ущерб. Как это делается — по признакам в Метрике, Вебвизоре и Вебмастере — подробно разобрано в статье про ",
            { to: "/blog/priznaki-neestestvennogo-trafika", text: "признаки неестественного трафика" },
            ". Здесь — только то, что нужно для защиты.",
          ],
        },
        {
          type: "List",
          listType: "ul",
          items: [
            { bold: "Сегмент вместо общей статистики. ", text: "Постройте в Метрике сегмент по подозрительным параметрам — источник, регион, длительность, технологии — и дальше работайте с ним, а не со всей выборкой." },
            { bold: "Группировка по сети, а не по адресу. ", text: "В логах смотрите не на отдельные IP, а на принадлежность к сетям: массовый трафик из адресных пространств хостинг-провайдеров и дата-центров живой аудиторией не бывает." },
            { bold: "Сверка с Вебмастером. ", text: "Если визитов стало больше, а показов и кликов в поиске столько же — источник роста не поисковый." },
          ],
        },
      ],
    },
    {
      id: "chto-rabotaet",
      title: "Шаг 3. Что действительно работает",
      content: [
        {
          type: "Description",
          text: "Меры ниже расставлены по соотношению пользы и риска — от самых безопасных к тем, которые требуют аккуратности.",
          style: { marginBottom: "8px" },
        },
        {
          type: "List",
          listType: "ol",
          items: [
            { bold: "Ограничение частоты запросов. ", text: "Лимит на число запросов с одного адреса за минуту. Отсекает сканеры и парсеры, живому посетителю незаметен. Порог подбирается по своим же логам: посмотрите, сколько запросов в минуту делает реальный пользователь, и возьмите запас." },
            { bold: "Отсечение трафика дата-центров. ", text: "Ограничение или проверка для запросов из адресных пространств хостинг-провайдеров. Домашние и мобильные сети при этом не трогаются." },
            { bold: "Невидимая проверка вместо капчи. ", text: "Современные защитные сервисы проверяют клиента без участия человека и показывают что-либо только подозрительным запросам. Это принципиально лучше, чем капча для всех." },
            { bold: "Кэширование и запас по мощности. ", text: "Если посторонний трафик не роняет сайт, он не портит и скорость для живых посетителей — а скорость поисковые системы учитывают напрямую." },
            { bold: "Журналирование и регулярный просмотр. ", text: "Защита без наблюдения перестаёт работать через месяц, потому что источник меняет поведение, а вы об этом не узнаёте." },
          ],
        },
        {
          type: "Subtotal",
          title: "Чего эти меры не делают",
          text: "Они не удаляют уже учтённые визиты и не откатывают статистику назад. Их задача — прекратить поступление, а не переписать прошлое.",
        },
      ],
    },
    {
      id: "chego-ne-delat",
      title: "Чего делать не надо",
      content: [
        {
          type: "Description",
          text: "Этот список важнее предыдущего: перечисленное ниже вредит сайту заметнее, чем сама накрутка.",
          style: { marginBottom: "8px" },
        },
        {
          type: "List",
          listType: "ul",
          items: [
            { bold: "Сложная капча на входе. ", text: "Отсекает вместе с роботами часть покупателей и портит поведенческие метрики уже вашими руками." },
            { bold: "Блокировка по странам и регионам. ", text: "Обходится тривиально, а живых посетителей и часть поисковых роботов задевает по-настоящему." },
            { bold: "Разный контент роботу и человеку. ", text: "Попытка отдать поисковому роботу «чистую» версию страницы — это клоакинг. Санкции за него — вопрос времени, в отличие от гипотетического вреда от чужой накрутки." },
            { bold: "Переезд на новый домен «на всякий случай». ", text: "Переезд сам по себе стоит просадки на время склейки. Делать его без подтверждённой причины — менять неизвестный ущерб на известный." },
            { bold: "Блокировка всего, что похоже на робота. ", text: "В этот список легко попадают краулеры поисковиков и превью-боты мессенджеров. Проверяйте, кого именно вы закрываете." },
            { bold: "Ответная накрутка конкурента. ", text: "Не помогает вашему сайту ничем: его метрики от этого не улучшаются. Плюс это прямое основание для претензий — недобросовестная конкуренция." },
          ],
        },
      ],
    },
    {
      id: "kuda-obrashchatsya",
      title: "Куда обращаться",
      content: [
        {
          type: "Description",
          parts: [
            "Начните с раздела «Диагностика» в Яндекс Вебмастере: там поисковая система сама сообщает о найденных проблемах сайта. Если просадка есть, а диагностика молчит, имеет смысл написать в поддержку Вебмастера — со ссылкой на конкретные запросы, датой начала и выгрузками. Общие рекомендации по структуре и качеству сайта Яндекс публикует в ",
            { href: "https://yandex.ru/support/webmaster/recommendations/site-structure.html", text: "справке для вебмастеров" },
            ".",
          ],
        },
        {
          type: "Description",
          text: "К обращению приложите то, что собрали на первом шаге: дату начала, отчёты до и после, характер трафика. Обращение без данных обычно заканчивается общим ответом.",
        },
      ],
    },
    {
      id: "chto-ukreplyat",
      title: "Что укрепить параллельно",
      content: [
        {
          type: "Description",
          text: "Пока идёт разбирательство, полезнее всего заниматься тем, что находится в вашей зоне влияния — и что одновременно снижает чувствительность сайта к чужим действиям.",
          style: { marginBottom: "8px" },
        },
        {
          type: "List",
          listType: "ul",
          items: [
            { text: "Скорость загрузки и стабильность: медленный сайт проседает и без посторонней помощи." },
            { text: "Соответствие страницы запросу — по нему поиск и оценивает, решил ли человек свою задачу." },
            { text: "Брендовый спрос: узнаваемость и прямые заходы живых людей — сигнал, который чужой накруткой не подделывается." },
            { text: "Полнота ответа на странице: разделы, контакты, условия. Посетителю должно быть незачем возвращаться в поиск." },
          ],
        },
        {
          type: "Description",
          parts: [
            "Если после этого вы хотите работать с поведенческими метриками не оборонительно, а осознанно — смысл имеет только то, что делают живые люди в обычном режиме. Как устроены такие сценарии, описано на странице ",
            { to: "/nakrutka-pf-yandex", text: "сценариев с реальными тестировщиками" },
            "; чем они отличаются от автоматических, разобрано в статье ",
            { to: "/blog/testirovshchiki-ili-tehnicheskie-agenty", text: "про тестировщиков и технических агентов" },
            ".",
          ],
        },
      ],
    },
    {
      id: "korotko",
      title: "Коротко",
      content: [
        {
          type: "List",
          listType: "ul",
          items: [
            { text: "Сначала зафиксируйте дату, отчёты и логи — потом их уже не будет." },
            { text: "Спросите своего подрядчика, не его ли это работа. Это самая частая разгадка." },
            { text: "Работают ограничение частоты запросов, отсечение дата-центров и невидимые проверки." },
            { text: "Капча для всех, блокировки по странам, разный контент роботу и человеку, переезд на новый домен — вредят сильнее проблемы." },
            { text: "Ответная накрутка конкурента не улучшает ваши метрики и создаёт юридический риск." },
            { text: "Параллельно занимайтесь скоростью, соответствием запросу и брендовым спросом — это работает независимо от чужих действий." },
          ],
          classes: ["nomargin"],
        },
      ],
    },
  ],
};

export default article;
